import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

import Card from "@material-ui/core/Card";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import { handleECPayment } from "../util/api";
import Swal from "sweetalert2";

// import Card from "@material-ui/core/Card";

const UserEventCard = ({ event, uid }) => {
  const { userEvents, userEventsLoading } = useSelector(
    (state) => state.events
  );
  let isExpired = false;
  let payment_status;
  const now = new Date().getTime();

  if (event.endDate < now || now < event.startDate) {
    isExpired = true;
  }

  if (event.isPass) {
    if (event.isPaid || event.price === 0) {
      payment_status = <IsPardText>報名成功</IsPardText>;
    } else {
      payment_status = (
        <React.Fragment>
          <MonetizationOn onClick={() => handlePurchase(event.id)} />
          <p>未付款</p>
        </React.Fragment>
      );
    }
  } else {
    payment_status = (
      <React.Fragment>
        <p>未通過審核</p>
      </React.Fragment>
    );
  }

  const handleDisplayDate = (date) => {
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  };

  const handlePurchase = async (id, isExpired) => {
    const eventData = userEvents.filter((event) => event.id === id)[0];

    let price;
    if (+eventData.numOfParticipant >= +eventData.discount_amount) {
      price =
        +eventData.numOfParticipant *
        +eventData.price *
        (+eventData.discount_rate * 0.1);
    } else {
      price = +eventData.numOfParticipant * +eventData.price;
    }
    const data = {
      trade_name: eventData.eventName,
      trade_phone: eventData.tel,
      county: "",
      district: "",
      zipcode: "",
      event_id: eventData.eventId,
      order_id: eventData.id,
      amount_price: price,
      user_id: uid,
    };

    handleECPayment(data).then((res) => {
      document.open();
      document.write(res.data);
      document.close();
    });
  };

  const handleOpenDetail = (id) => {
    let detail = userEvents.filter((event) => event.id === id)[0].summary;
    Swal.fire({
      html: `<div style="display:flex; justify-content: flex-start; text-align: left">
          <p>${detail}</p>
        </div>`,
    });
  };

  return (
    <CustomCard>
      <CustomCardRow>
        <CustomCardRowTitle>活動名稱</CustomCardRowTitle>
        <CustomCardRowText>{event.eventName}</CustomCardRowText>
      </CustomCardRow>
      <CustomCardRow>
        <CustomCardRowTitle>時間</CustomCardRowTitle>
        <CustomCardRowText>
          {handleDisplayDate(new Date(event.startDate))} ~{" "}
          {handleDisplayDate(new Date(event.endDate))}
        </CustomCardRowText>
      </CustomCardRow>
      <CustomCardRow>
        <CustomCardRowTitle>參加人數</CustomCardRowTitle>
        <CustomCardRowText>{event.numOfParticipant}</CustomCardRowText>
      </CustomCardRow>
      <CustomCardRow>
        <CustomCardRowTitle>影片連結</CustomCardRowTitle>
        <CustomCardRowText>
          {!event.isPaid && event.price !== 0
            ? "於付款後開放連結"
            : isExpired
            ? "非活動期間"
            : event.eventLink
            ? "線上活動連結"
            : "實體活動"}
        </CustomCardRowText>
      </CustomCardRow>
      <CustomCardRow>
        <CustomCardRowTitle>總價</CustomCardRowTitle>
        <CustomCardRowText>
          {event.price === 0 ? "免費活動" : event.price}
        </CustomCardRowText>
      </CustomCardRow>
      <CustomCardRow>
        <CustomCardRowTitle>付款</CustomCardRowTitle>
        <CustomCardRowText>{payment_status}</CustomCardRowText>
      </CustomCardRow>
      <CustomCardRow>
        <CustomCardRowTitle>內容</CustomCardRowTitle>
        <CustomCardRowText onClick={() => handleOpenDetail(event.id)}>
          活動內容
        </CustomCardRowText>
      </CustomCardRow>
    </CustomCard>
  );
};

const CustomCard = styled(Card)`
  width: 95%;
  margin: 10px 2.5%;
`;

const CustomCardRow = styled.div`
  width: 100%;
  display: flex;
  padding: 5px;
`;

const CustomCardRowTitle = styled.p`
  width: 100px;
  font-weight: 600;
`;

const CustomCardRowText = styled.p`
  font-size: ${(p) => p.isMore && "10px"};
  font-size: ${(p) => p.isMore && "10px"};
  font-size: ${(p) => p.isMore && "10px"};
`;

const IsPardText = styled.p`
  color: #32d608;
  font-weight: 600;
  font-size: 14px;
`;

export default UserEventCard;
